export default __webpack_public_path__ + "static/media/espago-screenshot-01.c9d5e44c.png";